import api from '../api'

export default {
    namespaced: true,
    state: {
        functionList: {// 备份下载页

        },
        listPaymentPage: {// 支付页面配置
            header: '',
            footer: '',
        }
    },
    mutations: {
        setStateFunctionList(state, info) {
            state.functionList = info
        },
        setStateListPaymentPage(state, info) {
            state.listPaymentPage = info
        }
    },
    actions: {
        getFunctionList({commit}) {
            return api.get('/functionSwitchConfig/list', '列出功能开关和备份下载').then(res => {
                commit('setStateFunctionList', res.data)
            })
        },
        updateSwitchFunction({dispatch}, params) {
            return api.post('/functionSwitchConfig/update', '修改功能开关', params).then(() => {
                dispatch('getFunctionList')
            })
        },
        updateUrlSetting({dispatch}, params) {
            return api.post('/functionSwitchConfig/updateUrlSetting', '修改URL设置', params).then(() => {
                dispatch('getFunctionList')
            })
        },
        getListPaymentPage({commit}) {
            return api.post('/functionSwitchConfig/listPaymentPage', '查询支付页面页头&页尾文案').then(res => {
                commit('setStateListPaymentPage', res.data)
            })
        },
        updatePaymentPage({dispatch}, params){
            return api.post('/functionSwitchConfig/updatePaymentPage', '更新支付页面页头/页尾文案',params).then(() => {
                dispatch('getListPaymentPage')
            })
        }
    }
}